import API from '@/api'
import { getToken, setToken, removeToken } from '@/utils/auth'
import router from '@/router' // 路由
import Store from '@/store'
import { MessageBox } from 'element-ui'
const state = {
  token: getToken(),
  userInfo: {},
  sid: '',
  captchaURL: '',
  graduationDate: '',
  thesisProcess: []
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = 'Bearer' + ' ' + token
  },
  SET_USER_INFO(state, data) {
    state.userInfo = {
      ...state.userInfo,
      ...data
    }
  },
  SET_SID(state, data) {
    state.sid = data
  },
  SET_CAPTCHA_URL(state, data) {
    state.captchaURL = data
  },
  SET_GRADUATION_DATE(scope, data) {
    scope.graduationDate = data
  },
  STE_THESIS_PROCESS_LIST(state, data) {
    state.thesisProcess = data
  }
}

const actions = {
  // 获取用户信息，页面切换时调用
  GetUserInfo({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      const school_id = Store.state.app.appConfig.school_id
      API.userInfo(school_id).then(res => {
        if (+res.code === 200) {
          if (res.data === null) {
            MessageBox.confirm('您的登录凭证已失效，请重新登录', '提示', {
              confirmButtonText: '确定',
              showCancelButton: false,
              closeOnPressEscape: false,
              closeOnClickModal: false,
              showClose: false,
              type: 'warning'
            })
              .then(() => {
                dispatch('resetToken')
              })
              .catch(() => { })
          } else {
            commit('SET_USER_INFO', res.data)
            resolve(res.data)
          }
        }
      })
    })
  },
  /* 登录 */
  Login({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      API.Login(data)
        .then(res => {
          setToken(res.data.token)
          commit('SET_USER_INFO', res.data.user)
          dispatch('common/UserPortalData', '', { root: true })

          resolve()
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  /* 获取论文节点 */
  GetThesisNodeList({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      API.MBAThesisNodeList().then(res => {
        if (+res.code === 200) {
          commit('STE_THESIS_PROCESS_LIST', res.data.data)
          resolve(res.data)
        }
      })
    })
  },
  /* 登出 */
  async Logout({ dispatch }) {
    await API.Logout()
    await dispatch('resetToken')
    router.replace('/login')
  },
  /* 清空登录数据 */
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_USER_INFO', {})
      removeToken()
      window.localStorage.removeItem('student')
      resolve()
    })
  },
  /* 找回密码 创建会话 */
  async CreateSid({ commit, dispatch }) {
    const res = await API.CreateSid()
    if (+res.code === 200) {
      commit('SET_SID', res.data.sid)
      dispatch('Captcha', res.data.sid)
    }
  },
  /* 找回密码 图形验证码 */
  async Captcha({ commit, state }, sid) {
    const res = await API.Captcha(sid || state.sid)
    if (+res.code === 200) {
      commit('SET_CAPTCHA_URL', res.data.image)
    }
  },
  SendVerifyCode({ state }, data) {
    const postData = {
      sid: state.sid,
      ...data
    }
    return API.SendVerifyCode(postData)
  },
  restPasswod({ state, commit }, data) {
    const postData = {
      sid: state.sid,
      ...data
    }
    return API.restPasswod(postData)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
